// Fallback properties when no template is selected
const DEFAULT_JUDGE_DESCRIPTION =
  'Begin with a blank slate, most common for judges that have very specific use cases and complexity.';

const DEFAULT_JUDGE_IS_INVERTED = false;

const DEFAULT_JUDGE_TAGS = ['ai', 'judge'];

const DEFAULT_JUDGE_SYSTEM_MESSAGE = `You are an evaluator. Review the AI-generated response based on [REPLACE WITH CRITERIA].

EVALUATION FRAMEWORK:
Score the response on a 0.0–1.0 scale using the following rubric:
0.0–0.3: The response does not meaningfully satisfy the criteria. Key expectations are unmet, misapplied, or contradicted.
0.4–0.7: The response addresses the criteria at a surface or partial level. Some expectations are met, but there are notable gaps, weaknesses, or inconsistencies.
0.8–1.0: The response satisfies the criteria in a complete and consistent manner. Expectations are clearly addressed without significant gaps or contradictions.

SCORING PRIORITIES:
Alignment with criteria
Overall quality relative to the criteria`;

const DEFAULT_JUDGE_ASSISTANT_MESSAGE = `MESSAGE HISTORY:
{{message_history}}
`;

const DEFAULT_JUDGE_USER_MESSAGE = `RESPONSE TO EVALUATE:
{{response_to_evaluate}}
`;

export const DEFAULT_JUDGE_PROPERTIES = {
  description: DEFAULT_JUDGE_DESCRIPTION,
  isInverted: DEFAULT_JUDGE_IS_INVERTED,
  tags: DEFAULT_JUDGE_TAGS,
  messages: [
    {
      role: 'system',
      content: DEFAULT_JUDGE_SYSTEM_MESSAGE,
    },
    {
      role: 'assistant',
      content: DEFAULT_JUDGE_ASSISTANT_MESSAGE,
    },
    {
      role: 'user',
      content: DEFAULT_JUDGE_USER_MESSAGE,
    },
  ],
};
